var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsOsImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 278,
    height: 76,
    viewBox: "0 0 278 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8845",
    "data-name": "Group 8845",
    transform: "translate(-1041 -594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_522",
    "data-name": "Rectangle 522",
    transform: "translate(1041 594)",
    fill: "#fff",
    stroke: "#002147",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 278,
    height: 76,
    rx: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 277,
    height: 75,
    rx: 7.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g887",
    transform: "translate(1065 608)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M95.55,38.885H89.534L83.669,16.557l-5.93,22.328H71.59L63.524,9.863H68.98L74.8,32.948l6.35-23.085h5.511l5.968,23.222L98.15,9.863h5.269Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M111.13,11.986a2.535,2.535,0,0,1-.867,1.962,3.109,3.109,0,0,1-4.129,0,2.563,2.563,0,0,1-.847-1.962,2.652,2.652,0,0,1,.847-2,2.931,2.931,0,0,1,2.065-.805,2.827,2.827,0,0,1,2.085.826,2.671,2.671,0,0,1,.847,1.982Zm-5.442,26.9V17.969h4.876V38.884Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M129.33,38.885V27.24c0-3.051-.946-5.683-4.02-5.683-3.058,0-5,2.753-5,5.539V38.884h-4.77V17.969h4.77v2.958h.083c1.583-2.451,3.868-3.311,6.855-3.311,2.244,0,3.978.552,5.2,1.984s1.783,3.606,1.783,6.524V38.884Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M153.28,38.885V36.193H153.2c-1.514,2.547-4.6,3.134-6.76,3.134-6.4,0-8.754-4.975-8.754-10.269a12.77,12.77,0,0,1,2.622-8.424,8.6,8.6,0,0,1,7.061-3.037c4.585,0,5.831,2.551,5.831,2.551h.083V8.043h4.947V38.885Zm.041-11.918c0-2.527-1.624-5.4-5.05-5.4-3.92,0-5.443,3.411-5.443,7.343,0,3.433,1.438,6.548,5.171,6.6,3.66,0,5.294-3.489,5.323-6.373Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M183.186,28.335c0,7.245-4.33,11.169-10.832,11.169-7.071,0-10.7-4.233-10.7-10.715,0-7.416,4.343-11.273,11.211-11.273,6.293,0,10.316,4.023,10.316,10.819Zm-5.079.165c0-3.223-1.143-6.806-5.505-6.806-4.184,0-5.81,3.114-5.81,6.93,0,4.146,1.952,6.782,5.78,6.782,4.1,0,5.505-3.147,5.535-6.906Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M209.356,38.885h-5.381l-4.113-15.137-4.413,15.137h-5.223l-6.085-20.851h5.106l3.973,16.2,4.644-16.2h4.789L206.8,34.191l3.874-16.157h4.68Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M230.665,33.063c0,4.656-4.223,6.471-8.455,6.471a17.53,17.53,0,0,1-5.5-1.062V33.52a9.631,9.631,0,0,0,5.719,2.105c2.285,0,3.314-.721,3.314-2.092a2.278,2.278,0,0,0-1.415-2.163,20.754,20.754,0,0,0-2.581-1.218,13.341,13.341,0,0,1-3.076-1.714,5.321,5.321,0,0,1-1.487-1.941,6.329,6.329,0,0,1-.55-2.551c0-3.76,3.136-6.417,8.148-6.417a10.447,10.447,0,0,1,4.749.812v4.705a9.922,9.922,0,0,0-4.8-1.642c-1.753,0-3.078.638-3.1,2.083-.012,1.862,2.267,2.769,3.628,3.32a10.768,10.768,0,0,1,4.245,2.628,5.074,5.074,0,0,1,1.165,3.628Z",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect18",
    width: 23.105,
    height: 23.105,
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect20",
    width: 23.105,
    height: 23.105,
    transform: "translate(25.64)",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect22",
    width: 23.105,
    height: 23.105,
    transform: "translate(0 25.642)",
    fill: "#0078d4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect24",
    width: 23.105,
    height: 23.105,
    transform: "translate(25.64 25.642)",
    fill: "#0078d4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsOsImg);
export default __webpack_public_path__ + "static/media/windows-os-img.7408aef1018d59af027422672f75690b.svg";
export { ForwardRef as ReactComponent };